/**
 * UTM Parameter Utilities
 * Reads UTM params from URL, stores in sessionStorage, retrieves for Stripe/forms.
 */

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const UTM_STORAGE_KEY = 'pos_utm_params';

/**
 * Read UTM params from current URL and store in sessionStorage.
 * Call this on landing page mount.
 */
export function captureUTMParams() {
  const params = new URLSearchParams(window.location.search);
  const utms = {};
  let hasAny = false;

  if (!sessionStorage.getItem("pos_landing_page")) {
    sessionStorage.setItem("pos_landing_page", window.location.href);
  }
  if (document.referrer && !sessionStorage.getItem("pos_referrer")) {
    sessionStorage.setItem("pos_referrer", document.referrer);
  }

  UTM_PARAMS.forEach((key) => {
    const val = params.get(key);
    if (val) {
      utms[key] = val;
      hasAny = true;
    }
  });

  if (hasAny) {
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utms));
  }

  return utms;
}

/**
 * Retrieve stored UTM params from sessionStorage.
 * Returns object with utm_source, utm_medium, etc. (empty strings if not set).
 */
export function getStoredUTMs() {
  try {
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    // ignore parse errors
  }
  return {};
}

/**
 * Get UTM params as a flat object safe to spread into API payloads.
 */
export function getUTMPayload() {
  const utms = getStoredUTMs();
  return {
    utm_source: utms.utm_source || '',
    utm_medium: utms.utm_medium || '',
    utm_campaign: utms.utm_campaign || '',
    utm_content: utms.utm_content || '',
    utm_term: utms.utm_term || '',
  };
}
